<template><div><h1 id="_5-activecampaign-schnittstelle" tabindex="-1"><a class="header-anchor" href="#_5-activecampaign-schnittstelle"><span>5. ActiveCampaign-Schnittstelle</span></a></h1>
<p>Über diese Schnittstelle können Daten für das E-Mail Marketing mit ActiveCampaign ausgetauscht werden. Insbesondere betrifft das den Austausch von Adressdaten, Versänden, Publikationen und Merkmalen.</p>
<p>Dokumentation: <em><a href="https://ops.arenae.ch/ftdoc/documents/Schnittstelle_ActiveCampaign.pdf" target="_blank" rel="noopener noreferrer">Schnittstellenbeschreibung Active Campaign</a></em> .</p>
</div></template>


